import { render } from "./AdminPassword.vue?vue&type=template&id=1762beea&scoped=true"
import script from "./AdminPassword.vue?vue&type=script&lang=js"
export * from "./AdminPassword.vue?vue&type=script&lang=js"

import "./AdminPassword.vue?vue&type=style&index=0&id=1762beea&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1762beea"]])

export default __exports__